const locale = {
  login: 'Log In',
};

export default locale;
